import { getPlanningEntityIdentifiersFromEvent } from 'components/mrp/components/Calendar/components/CalendarAppointment/CalenderAppointment.utils';
import { DuplicateEventProps } from './utils.types';
import { getFormData } from './getFormData';
import dayjs from 'dayjs';
import { DayIndex } from 'components/mrp/components/AppointmentForm/components/RecurrencePatternBuilder/RecurrencePatternBuilder.types';
import { PlanningEntityIdentifier } from 'generated/index';

export const duplicateEvent = async ({
  event,
  setIsProcessing,
  createAppointment,
  asRecurring = false
}: DuplicateEventProps) => {
  setIsProcessing(true);

  try {
    const date = dayjs(event.planningEvent.start);

    // Entities from the appointment
    const sourceEntities = getPlanningEntityIdentifiersFromEvent(
      event.planningEvent
    );

    // For duplication: same entities, same place, same time
    const targetEntities = sourceEntities;
    const entitiesToReplace: PlanningEntityIdentifier[] = []; // No replacement needed
    const entitiesToRefetch = sourceEntities;

    const formData = getFormData({
      baseEvent: event.planningEvent,
      isCut: false,
      newStart: date,
      sourceEntities,
      targetEntities,
      entitiesToReplace
    });

    // Remove ID to force brand new appointment creation
    formData.id = undefined;
    formData.appointmentExceptions = undefined;
    formData.editAppointmentType = undefined;

    if (asRecurring) {
      // Create an infinite recurring appointment
      const dayOfWeek = (date.isoWeekday() - 1) as DayIndex;
      formData.isRecurring = true;
      formData.recurrencePattern = {
        recurrenceRule: 'weekly',
        recurrenceRangeType: 'NO_END',
        recurrenceInterval: 1,
        daysSelected: [dayOfWeek],
        recurrenceEnd: undefined
      };
    } else {
      // Create a single non-recurring appointment
      formData.isRecurring = false;
      formData.recurrencePattern = {
        recurrenceRule: 'none',
        recurrenceRangeType: 'NO_END',
        daysSelected: []
      };
    }

    await createAppointment(formData, entitiesToRefetch);
  } catch (error) {
    console.error(
      `Error duplicating ${asRecurring ? 'recurring ' : ''}appointment:`,
      error
    );
  } finally {
    setIsProcessing(false);
  }
};
